<!--
 * @Author: heroDHB
 * @Date: 2020-07-29 16:39:38
-->
<template>
  <div class="cheji">
    <img class="top" src="../../assets/imgs/home/top.jpg" />
    <div class="cheji-box">
      <img class="slide-img top" src="../../assets/imgs/home/cj-top.jpg" />
      <div class="center">
        <img class="slide-img left" src="../../assets/imgs/home/cj-left.jpg" />
        <div class="cheji-swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="id in [0, 1, 2, 3, 4]" :key="id">
              <img :src="require(`../../assets/topbanner/${id}.jpg`)" />
            </div>
          </div>
        </div>
        <img class="slide-img right" src="../../assets/imgs/home/cj-right.jpg" />
      </div>
      <img class="slide-img bottom" src="../../assets/imgs/home/cj-bottom.jpg" />
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper/swiper-bundle.min';

export default {
  name: 'Cheji',
  data() {
    return {};
  },
  mounted() {
    // eslint-disable-next-line no-new
    new Swiper('.cheji-swiper', {
      loop: true,
      autoplay: {
        autoplay: true,
        disableOnInteraction: false,
      },
    });
  },
};
</script>

<style lang="less" scoped>
.cheji {
  margin-bottom: 10px;
  .top {
    width: 750px;
    height: 503px;
  }
  .cheji-box {
    .top {
      width: 750px;
      height: 50px;
    }
    .bottom {
      width: 750px;
      height: 186px;
    }
    .center {
      display: flex;
      .cheji-swiper {
        width: 536px;
        height: 322px;
        overflow: hidden;
        .swiper-slide {
          background: #010007;
          > img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .left {
        width: 130px;
        height: 322px;
      }
      .right {
        width: 84px;
        height: 322px;
      }
    }
    .slide-img {
      display: block;
      pointer-events: none;
    }
  }
}
</style>
